import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { RequireRole } from "./auth/RequireRole";
import { DashboardLayout } from "./layout/DashboardLayout";
import { AdminPage } from "./pages/AdminPage";
import { BookingsPage } from "./pages/BookingsPage";
import { CalendarPage } from "./pages/CalendarPage";
import { ContractsPage } from "./pages/ContractsPage";
import { CrmPage } from "./pages/CrmPage";
import { ChatsPage } from "./pages/ChatsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FinancePage } from "./pages/FinancePage";
import { PayoutsPage } from "./pages/PayoutsPage";
import { HallsPage } from "./pages/HallsPage";
import { HrPage } from "./pages/HrPage";
import { LoginPage } from "./pages/LoginPage";
import { ReviewsPage } from "./pages/ReviewsPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireRole roles={["owner", "manager", "staff"]}>
                <DashboardLayout />
              </RequireRole>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/contracts" element={<ContractsPage />} />
            <Route path="/chats" element={<ChatsPage />} />
            <Route path="/finance" element={<FinancePage />} />
            <Route path="/payouts" element={<PayoutsPage />} />
            <Route path="/hr" element={<HrPage />} />
            <Route path="/crm" element={<CrmPage />} />
            <Route path="/halls" element={<HallsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route
              path="/admin"
              element={
                <RequireRole roles={["admin"]}>
                  <AdminPage />
                </RequireRole>
              }
            />
            {/* Unknown/removed paths (e.g. the old /inventory) fall back to the
                dashboard instead of a blank content area. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
